// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";


// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAVUQG_wzMhm8S97FNMaKZpBAE_ehROWsQ",
  authDomain: "resqgen-e8302.firebaseapp.com",
  projectId: "resqgen-e8302",
  storageBucket: "resqgen-e8302.firebasestorage.app",
  messagingSenderId: "400128707303",
  appId: "1:400128707303:web:98991580ecc320c90fb042",
  measurementId: "G-Y0NY6K0MNB"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();